import React from "react";
import TitleComponent from "../../components/title/Title";
import PaymentTable from "./PaymentTable";

function PaymentMain() {
  return (
    <div className="body--container">
      <TitleComponent title="Payments" />
      <PaymentTable />
    </div>
  );
}

export default PaymentMain;
